import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, InputGroup, Form, Breadcrumb } from "react-bootstrap";
import { Icon } from "@iconify/react";
import UploadImageComponent from "../../components/UploadImageComponent";
import { useStore } from "../../store";
import { useNavigate } from "react-router-dom";
import { get_membe_by_member_no } from "../../services/membership.service";
import converSex from "../../helpers/convertSex";
import { END_IMAGE } from "../../constants";
import convertNumber from "../../helpers/convertNumber";
import convertNumberReverse from "../../helpers/convertNumberReverse";
import convertTypeLoan from "../../helpers/convertTypeLoan";
import LoadingComponent from "../../components/LoadingComponent";
import FormControlCustom from "../../components/FormControlCustom";
import { WarningError } from "../../helpers/alertseet";
import addBranchNo from "../../helpers/addBranchNo";
import { add_loan } from "../../services/loan.service";

export default function CreateLoanPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [inputSearch, setInputSearch] = useState("");
  const [memberData, setMemberData] = useState(null);
  const [selectLoanType, setSelectLoanType] = useState("");
  const [disableButton, setDisableButton] = useState(false);
  const [formData, setFormData] = useState({});
  console.log("formData: ", formData);
  const [validate, setValidate] = useState({
    branchId: false,
    memberId: false,
    description: false,
    loanAmount: false,
    loanTerm: false,
    loanType: false,
    contractImage: false,
    exceptPaymentFirstTwoTerm: false,
    interestRate: false,
  });
  const [validateMessage, setValidateMessage] = useState({
    balanceAmount: "",
    description: "",
    memberData: "",
  });

  const { token, branchData } = useStore();

  useEffect(() => {
    if (selectLoanType === "DECREASE_INTEREST") {
      setFormData((prev) => ({ ...prev, loanType: "DECREASE_INTEREST" }));
    } else if (selectLoanType === "CONSTANT_INTEREST_AND_CLOSURE_INTEREST") {
      setFormData((prev) => ({
        ...prev,
        loanType: formData.loanType || "CONSTANT_INTEREST",
      }));
    } else {
      setFormData((prev) => ({ ...prev, loanType: selectLoanType }));
    }
  }, [selectLoanType]);

  const checkValidate = () => {
    const newValidate = {
      branchId: !formData.branchId,
      memberId: !memberData?._id,
      description: !formData.description,
      loanAmount: !formData.loanAmount || formData.loanAmount <= 0,
      loanTerm: !formData.loanTerm,
      loanType: !formData.loanType,
      interestRate: !formData.interestRate,
      // contractImage: !formData.contractImage,
    };

    setValidate(newValidate);
    setValidateMessage({
      ...validateMessage,
      memberData: !memberData?._id ? "ກະລຸນາປ້ອນເລກສະມາຊິກໃຫ້ຖືກຕ້ອງ" : "",
      loanAmount:
        !formData.loanAmount || formData.loanAmount <= 0
          ? "ກະລຸນາປ້ອນຈຳນວນເງິນກູ້"
          : "",
    });

    return Object.values(newValidate).some((value) => value);
  };

  const handleSearchMember = async () => {
    try {
      if (!inputSearch) {
        setValidate((prev) => ({ ...prev, memberId: true }));
        setValidateMessage((prev) => ({
          ...prev,
          memberData: "ກະລຸນາປ້ອນເລກສະມາຊິກ",
        }));
        return;
      }

      setSearchLoading(true);
      const response = await get_membe_by_member_no(
        addBranchNo(inputSearch, branchData?.branchNo),
        token
      );

      if (response?.data) {
        setMemberData(response.data);
        setFormData((prev) => ({ ...prev, memberId: response.data._id }));
        setValidate((prev) => ({ ...prev, memberId: false }));
        setValidateMessage((prev) => ({ ...prev, memberData: "" }));
      } else {
        setMemberData(null);
        setFormData((prev) => ({ ...prev, memberId: "" }));
        setValidate((prev) => ({ ...prev, memberId: true }));
        setValidateMessage((prev) => ({
          ...prev,
          memberData: "ບໍ່ພົບຂໍ້ມູນສະມາຊິກ",
        }));
      }
    } catch (error) {
      console.error("Error fetching member:", error);
      WarningError("ເກີດຂໍ້ຜິດພາດໃນການຄົ້ນຫາສະມາຊິກ");
      setMemberData(null);
      setValidate((prev) => ({ ...prev, memberId: true }));
    } finally {
      setSearchLoading(false);
    }
  };

  const handleCreateLoan = async () => {
    checkValidate();
    try {
      setIsLoading(true);
      const newDataForm = {
        ...formData,
        memberId: memberData?._id,
        interestRate: parseFloat(formData.interestRate) * 0.01,
      };
      console.log("newDataForm: ", newDataForm);
      const response = await add_loan(newDataForm, token);
      console.log("response: ", response?.data);
      if (response?.data) {
        navigate("/loan", { replace: true });
      }
    } catch (err) {
      console.error("Error creating loan:", err);
      WarningError("ເກີດຂໍ້ຜິດພາດໃນການສ້າງລາຍການເງິນກູ້");
    } finally {
      setDisableButton(false);
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({});
    setValidate({});
    setMemberData(null);
    setInputSearch("");
    navigate("/loan", { replace: true });
  };

  return (
    <div className="create-loan-page">
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => navigate("/loan")}>
          ປ່ອຍກູ້ ແລະ ເກັບຄືນ
        </Breadcrumb.Item>
        <Breadcrumb.Item active>ສ້າງລາຍການ</Breadcrumb.Item>
      </Breadcrumb>

      <div className="page-content" style={{ padding: "20px" }}>
        <h4
          style={{
            marginBottom: "20px",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          ປ້ອນຂໍ້ມູນເງີນກູ້
        </h4>

        <div style={{ marginBottom: 20 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 5,
            }}
          >
            <label>ເລກສະມາຊິກ</label>
            <label>(ກົດປຸ່ມເພື່ອຄົ້ນຫາ)</label>
          </div>
          <InputGroup>
            <Form.Control
              maxLength="4"
              placeholder="ປ້ອນເລກສະມາຊິກ"
              value={inputSearch}
              onChange={(e) => {
                convertNumberReverse(e.target.value, (value) => {
                  setInputSearch(value);
                });
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSearchMember();
                }
              }}
              isInvalid={validate.memberId}
            />
            <InputGroup.Text
              style={{
                backgroundColor: "#0178C1",
                border: "none",
                cursor: "pointer",
              }}
              onClick={handleSearchMember}
            >
              <Icon
                icon="tabler:search"
                style={{ width: 24, height: 24, color: "#FFFFFF" }}
              />
            </InputGroup.Text>
          </InputGroup>
          {validate.memberId && validateMessage.memberData && (
            <div
              style={{
                color: "#FF0000",
                display: "flex",
                gap: 5,
                marginTop: 5,
              }}
            >
              <Icon
                icon="material-symbols:info-outline"
                style={{ width: 18, height: 18 }}
              />
              <span>{validateMessage.memberData}</span>
            </div>
          )}
        </div>

        {searchLoading ? (
          <div
            style={{ display: "flex", justifyContent: "center", height: 150 }}
          >
            <LoadingComponent />
          </div>
        ) : (
          memberData && (
            <div style={{ marginBottom: 20 }}>
              {[
                {
                  title: "ຊື່ ແລະ ນາມສະກຸນ:",
                  value: memberData.fullName || "-",
                },
                { title: "ເພດ:", value: converSex(memberData.gender) || "-" },
                // {
                //   title: "ຈຳນວນເງິນອອມ (ກີບ):",
                //   value: memberData.balanceId?.totalBalance
                //     ? convertNumber(memberData.balanceId.totalBalance)
                //     : "-",
                // },
                // {
                //   title: "ຄະແນນ:",
                //   value: memberData.balanceId?.totalPoint
                //     ? convertNumber(memberData.balanceId.totalPoint)
                //     : "-",
                // },
              ].map((item, index) => (
                <div key={index} style={{ display: "flex", marginBottom: 10 }}>
                  <div style={{ width: "40%" }}>{item.title}</div>
                  <div style={{ width: "60%" }}>{item.value}</div>
                </div>
              ))}
            </div>
          )
        )}

        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຈຳນວນເງິນກູ້ (ກີບ)</Form.Label>
          <FormControlCustom
            placeholder="ປ້ອນຈຳນວນເງິນກູ້"
            type="text"
            value={convertNumber(formData?.loanAmount) || ""}
            isInvalid={validate.loanAmount}
            isInvalidMessage={validateMessage.loanAmount}
            onChange={(e) => {
              convertNumberReverse(e.target.value, (value) => {
                setFormData((prev) => ({ ...prev, loanAmount: value }));
              });
            }}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <Form.Label>ດອກເບ້ຍ (%)</Form.Label>
          <Form.Control
            value={formData?.interestRate}
            type="text"
            placeholder="ປ້ອນດອກເບ້ຍ"
            onChange={(e) => {
              const value = e.target.value;
              if (value.length <= 3) {
                setFormData((prev) => ({ ...prev, interestRate: value }));
              }
            }}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຈຳນວນງວດ (ເດືອນ)</Form.Label>
          <FormControlCustom
            placeholder="ປ້ອນຈຳນວນງວດ"
            type="text"
            value={convertNumber(formData?.loanTerm) || ""}
            isInvalid={validate.loanAmount}
            isInvalidMessage={validateMessage.loanTerm}
            maxLength={2}
            onChange={(e) => {
              convertNumberReverse(e.target.value, (value) => {
                setFormData((prev) => ({ ...prev, loanTerm: value }));
              });
            }}
          />
          {validate.loanTerm && (
            <div
              style={{
                color: "#FF0000",
                display: "flex",
                gap: 5,
                marginTop: 5,
              }}
            >
              <Icon
                icon="material-symbols:info-outline"
                style={{ width: 18, height: 18 }}
              />
              <span>ກະລຸນາເລືອກຈຳນວນງວດ</span>
            </div>
          )}
        </div>

        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຮູບແບບການຊຳລະດອກເບ້ຍ</Form.Label>
          <Form.Select
            value={selectLoanType}
            isInvalid={validate.loanType}
            onChange={(e) => {
              setSelectLoanType(e.target.value);
            }}
          >
            <option value="" disabled>
              ເລືອກປະເພດ
            </option>
            <option value="DECREASE_INTEREST">
              {convertTypeLoan("DECREASE_INTEREST")}
            </option>
            <option value="ALL_CONSTANT_INTEREST">
              {convertTypeLoan("ALL_CONSTANT_INTEREST")}
            </option>
            <option value="CONSTANT_INTEREST_AND_CLOSURE_INTEREST">
              ດອກເບ້ຍຄົງທີ່ ແລະ ບໍ່ໄດ້ຊຳລະຕົ້ນທືນ
            </option>
          </Form.Select>
          {validate.loanType && (
            <div
              style={{
                color: "#FF0000",
                display: "flex",
                gap: 5,
                marginTop: 5,
              }}
            >
              <Icon
                icon="material-symbols:info-outline"
                style={{ width: 18, height: 18 }}
              />
              <span>ກະລຸນາເລືອກປະເພດ</span>
            </div>
          )}
        </div>

        {selectLoanType === "CONSTANT_INTEREST_AND_CLOSURE_INTEREST" && (
          <div style={{ marginBottom: 20 }}>
            <Form.Label>ຕົວເລືອກ</Form.Label>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <Form.Check
                type="radio"
                label="ຊຳລະດອກເບ້ຍລາຍເດືອນ, ຕົ້ນທຶນຊຳລະຕາມໄລຍະສິ້ນສຸດທີ່ສັນຍາກຳນົດ"
                name="loanTypeOptions"
                value="CONSTANT_INTEREST"
                checked={formData?.loanType === "CONSTANT_INTEREST"}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, loanType: e.target.value }))
                }
              />
              <Form.Check
                type="radio"
                label="ຊຳລະດອກເບ້ຍ ຕາມໄລຍະສິ້ນສຸດທີ່ສັນຍາກຳນົດ ພ້ອມຕົ້ນທຶນ"
                name="loanTypeOptions"
                value="CLOSURE_INTEREST"
                checked={formData?.loanType === "CLOSURE_INTEREST"}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, loanType: e.target.value }))
                }
              />
            </div>
          </div>
        )}

        <div style={{ marginBottom: 20 }}>
          <Form.Label>ເຫດຜົນ</Form.Label>
          <Form.Control
            as="textarea"
            placeholder="ປ້ອນເຫດຜົນ"
            style={{ height: "100px" }}
            value={formData?.description || ""}
            isInvalid={validate.description}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, description: e.target.value }))
            }
          />
          {validate.description && (
            <div
              style={{
                color: "#FF0000",
                display: "flex",
                gap: 5,
                marginTop: 5,
              }}
            >
              <Icon
                icon="material-symbols:info-outline"
                style={{ width: 18, height: 18 }}
              />
              <span>ກະລຸນາປ້ອນລາຍລະອຽດ</span>
            </div>
          )}
        </div>

        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຮູບພາບສັນຍາ</Form.Label>
          <UploadImageComponent
            src={
              formData?.contractImage ? END_IMAGE + formData.contractImage : ""
            }
            isInvalid={validate.contractImage}
            style={{ width: "100%", height: "200px", maxHeight: "200px" }}
            onChange={(image) =>
              setFormData((prev) => ({ ...prev, contractImage: image }))
            }
          />
          {validate.contractImage && (
            <div
              style={{
                color: "#FF0000",
                display: "flex",
                gap: 5,
                marginTop: 5,
              }}
            >
              <Icon
                icon="material-symbols:info-outline"
                style={{ width: 18, height: 18 }}
              />
              <span>ກະລຸນາອັບໂຫລດຮູບສັນຍາ</span>
            </div>
          )}
        </div>

        <div style={{ display: "flex", gap: 10, marginTop: 30 }}>
          <Button
            variant="outline-primary"
            style={{ flex: 1 }}
            onClick={handleCancel}
            disabled={disableButton}
          >
            ຍົກເລີກ
          </Button>
          <Button
            style={{ flex: 1 }}
            onClick={handleCreateLoan}
            disabled={disableButton || isLoading}
          >
            {isLoading ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
          </Button>
        </div>
      </div>
    </div>
  );
}
